import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import nodeCardScreen01 from "@/assets/images/help/node-card-screen-01.png";

export default function HelpNodeCardScreen() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-6">
          <h1 className="text-2xl font-bold mb-2">
            Fellas Card – Mimbo Node Card Screen Guide
          </h1>
        </div>

        {/* Content */}
        <div className="space-y-6">
          <p className="text-sm font-semibold whitespace-pre-line">
            On the Mimbonode Card screen, you can manage your registered Fellas
            Cards.
            {"\n\n"}
            Key functions such as topping up, registering a physical card, and
            removing a card are easily accessible.
          </p>

          <div className="rounded-lg overflow-hidden shadow-md">
            <img
              src={nodeCardScreen01}
              alt="Node Card Screen"
              className="w-full h-auto"
            />
          </div>

          <p className="text-sm font-semibold whitespace-pre-line">
            {" "}· Top-Up: Allows you to top up a registered card.
            {"\n\n"}
            {" "}· Register: Register a physical card to enable card usage.
            {"\n\n"}
            {" "}· Remove: Removing a card will disable its use. Please proceed
            carefully.
          </p>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/8")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: How to Purchase a Card</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
